<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("add") }} {{ $tc("rateCardgroup", 1) }}
      </div>
    </div>

    <div class="section-space-50"></div>

    <div class="white-wrapper">
      <section class="mb-4 ml-3">
        <div class="row">
          <!-- SELECT CInema -->
          <div class="col-md-4 mb-2">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    RateCardGroupContainer.selected_cinema ? 'shift-up' : ''
                  "
                  >{{ $tc("cinema") }}</label
                >
                <multiselect
                  v-model="RateCardGroupContainer.selected_cinema"
                  :options="Cinemas"
                  label="cine_name"
                  track-by="cine_id"
                  :searchable="true"
                  placeholder=""
                  :preselect-first="true"
                  @select="selectCinema($event)"
                ></multiselect>
              </div>
              <!-- <Tooltip :title="$t('selectCinema')" /> -->
            </div>
            <p class="error_message">
              <span
                v-if="submitted && RateCardGroupContainer.cinema_id.length == 0"
                >{{ messagecinema }}</span
              >
            </p>
          </div>

          <!-- Rate Card group Name TITLE -->
          <div class="col-md-4 mb-2">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="RateCardGroupContainer.rc_g_name"
                  type="text"
                  name="movietitle"
                  id="movietitle"
                  v-validate="'required'"
                  placeholder="."
                />
                <label>{{ $tc("rateCardGroupTitle") }}</label>
              </div>
              <!-- <Tooltip :title="$t('nameOfRateCardgroup')" />    -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('movietitle')">{{
                errors.first("movietitle")
              }}</span>
            </p>
          </div>
          <div class="col-md-4 mb-2">
            <div class="row">
              <div class="col-md-2 mb-2">
                <label class="mb-1">{{ $t("active") }}</label>
              </div>
              <div class="col-md-9 mb-2">
                <b-form-checkbox
                  v-model="RateCardGroupContainer.rc_g_is_active"
                  name="check-button"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>

              <p class="error_message"></p>
            </div>
          </div>
        </div>
      </section>
      <section class="mb-5">
        <div
          class="row py-4 border mx-0 rounded mb-2"
          v-for="(
            RateCardGroup, RateCardGroupIndex
          ) in RateCardGroupContainer.RateGroupArray"
          :key="RateCardGroupIndex"
        >
          <div class="col-11 pl-0">
            <div class="col-12">
              <div class="row">
                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          RateCardGroup.selected_ticket_type ? 'shift-up' : ''
                        "
                        >{{ $tc("ticketType") }}</label
                      >
                      <multiselect
                        v-model="RateCardGroup.selected_ticket_type"
                        @select="selectTicketType($event, RateCardGroupIndex)"
                        :options="TicketTypes"
                        label="tt_name"
                        track-by="tt_id"
                        placeholder=""
                        :multiple="false"
                      />
                    </div>

                    <!-- <Tooltip :title="$t('Select ticket type')" /> -->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && RateCardGroup.tt_id.length == 0">{{
                      messagetickettype
                    }}</span>
                  </p>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          RateCardGroup.selected_rate_card ? 'shift-up' : ''
                        "
                        >{{ $tc("ratecard") }}</label
                      >
                      <multiselect
                        v-model="RateCardGroup.selected_rate_card"
                        @select="selectRateCard($event, RateCardGroupIndex)"
                        :options="RatecardsList"
                        track-by="rc_id"
                        label="rate_card_name"
                        :multiple="false"
                        placeholder=""
                      />
                    </div>
                    <!-- <Tooltip :title="$t('Rate Card Name')" /> -->
                  </div>
                  <p class="error_message">
                    <span
                      v-if="submitted && RateCardGroup.rate_card_id.length == 0"
                      >{{ messagepratecard }}</span
                    >
                  </p>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="row">
                    <div class="col-md-2 mb-2">
                      <label class="mt-1">{{ $t("Default") }}</label>
                    </div>
                    <div class="col-md-9 mb-2">
                      <b-form-checkbox
                        v-model="RateCardGroup.default_rate_card"
                        unchecked-value="N"
                        value="Y"
                        name="check-button"
                        switch
                        class="j-checkbox"
                      ></b-form-checkbox>
                    </div>

                    <p class="error_message"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-1 d-flex align-items-center justify-content-center border-left"
          >
            <button
              v-if="RateCardGroupIndex === 0"
              @click.prevent.stop="addCardGroup($event)"
              class="btn-transparent"
            >
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
            <button
              v-if="RateCardGroupIndex !== 0"
              @click.prevent.stop="removeCardGroup($event, RateCardGroupIndex)"
              class="btn-transparent"
            >
              <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
            </button>
          </div>
        </div>
      </section>
      <div class="col-md-12 text-center mt-4">
        <button
          :disabled="btenable"
          class="btn-blue"
          @click.prevent.stop="handleSubmit()"
        >
          {{ $t("save") }}
        </button>
        <button @click.prevent.stop="resetHandler" class="btn-black">
          {{ $t("reset") }}
        </button>
        <b-button
          class="btn-outline-grey"
          variant="default"
          to="/cinema-manager/view-rate-card-group"
          >{{ $t("cancel") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import scheduleService from "@/services/scheduleService";
import CinemasService from "@/services/CinemasService";
import Vue from "vue";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      selected_cinema: null,
      btenable: false,
      messagecinema: "Please Select Cinema.",
      messagepratecardgroup: "Please enter Rate card group",
      messagepratecard: "Please Select Rate card",
      messagetrailers: "Please Select Trailers.",
      messagetickettype: "Please Select Ticket Type",
      submitted: false,

      TicketTypes: [],
      Cinemas: [],
      RatecardsList: [],
      selected_ticket_type: "",
      selected_rate_card: "",

      RateCardGroupContainer: {
        rc_g_name: "",
        rc_g_is_active: true,
        cinema_id: "",
        RateGroupArray: [
          {
            tt_id: "",
            rate_card_id: "",
            default_rate_card: "Y",
          },
        ],
      },
    };
  },

  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemasList(obj);
    } else {
      this.getCinemasList();
    }
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getTicketTypeList();
  },
  mounted() {},
  methods: {
    resetHandler: function () {
      this.submitted = false;
      this.RateCardGroupContainer = {
        rc_g_name: "",
        cinema_id: "",
        rc_g_is_active: true,
        RateGroupArray: [
          {
            tt_id: "",
            rate_card_id: "",
            default_rate_card: "",
          },
        ],
      };
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      let body = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };
      MasterService.GetCinemasByRoles(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    getTicketTypeList: function () {
      this.TicketTypes = [];
      let body = {
        tableName: "ms_ticket_type",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.TicketTypes = data.Records.filter((x) => {
              return x.tt_is_active == "Y";
            });
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    getRatecardsList: function (cinema_id) {
      this.RatecardsList = [];
      scheduleService
        .GetRatecardByCinemaId({ cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RatecardsList = data.Records;
            console.log("ratecardlist", this.RatecardsList);
          } else {
            this.$toasted.show("No Rate Cards Found for selected cinema");
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },
    selectCinema(Cinema) {
      this.resetHandler();
      this.RateCardGroupContainer.cinema_id = Cinema.cine_id;
      this.getRatecardsList(Cinema.cine_id);
    },
    selectTicketType(tt, index) {
      console.log("container", this.RateCardGroupContainer);
      this.RateCardGroupContainer.RateGroupArray[index].tt_id = tt.tt_id;
    },
    selectRateCard(RateCard, index) {
      this.RateCardGroupContainer.RateGroupArray.map((x, i) => {
        if (
          x.rate_card_id == RateCard.rc_id &&
          x.tt_id == this.RateCardGroupContainer.RateGroupArray[index].tt_id
        ) {
          return this.$toasted.show("This Group is Already Selected");
        }
      });
      this.RateCardGroupContainer.RateGroupArray[index].rate_card_id =
        RateCard.rc_id;
    },
    removeCinema() {
      this.RateCardGroupContainer.cinema_id = "";
    },
    handleSubmit() {
      console.log(this.RateCardGroupContainer);
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        //Checking Basic details
        let commonGroup = false;
        this.RateCardGroupContainer.RateGroupArray.map((x, i) => {
          return this.RateCardGroupContainer.RateGroupArray.map((y, n) => {
            if (n !== i) {
              if (y.tt_id == x.tt_id && y.rate_card_id == x.rate_card_id) {
                commonGroup = true;
              }
            }
          });
        });

        var checkDefault = this.RateCardGroupContainer.RateGroupArray.filter(
          (group) => group.default_rate_card == "Y"
        );
        if (checkDefault.length > 1) {
          this.$toasted.show("Only one default group can be active");
          return;
        }
        if (checkDefault.length == 0) {
          this.$toasted.show("Atleast one default group Must be active");
          return;
        }
        if (commonGroup) {
          this.$toasted.show("Two Groups Must Not be Same");
          return;
        }

        if (
          this.RateCardGroupContainer.rc_id == "" ||
          this.RateCardGroupContainer.cinema_id == "" ||
          this.RateCardGroupContainer.rc_g_is_active == ""
        ) {
          return;
        }
        if (valid) {
          let payload = {
            RateGroupArray: this.RateCardGroupContainer.RateGroupArray,
            rc_g_name: this.RateCardGroupContainer.rc_g_name,
            rc_g_is_active: this.RateCardGroupContainer.rc_g_is_active,
            cinema_id: this.RateCardGroupContainer.cinema_id,
          };
          CinemasService.AddRateCardGroup(this.RateCardGroupContainer)
            .then((response) => {
              console.log("respo", response);
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.resetHandler();
                this.$router.push({
                  path: "/cinema-manager/view-rate-card-group",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
    addCardGroup: function (event) {
      let obj = {
        tt_id: "",
        rate_card_id: "",
        default_rate_card: "N",
      };
      this.RateCardGroupContainer.RateGroupArray.push(obj);
    },
    removeCardGroup: function (event, RateCardGroupIndex) {
      this.RateCardGroupContainer.RateGroupArray.splice(RateCardGroupIndex, 1);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RateCardGroupComponent/addRateCardGroup.vue